const TRANSLIT_MAP: Record<string, string> = {
  а: 'a',
  б: 'b',
  в: 'v',
  г: 'g',
  д: 'd',
  е: 'e',
  ё: 'e',
  ж: 'zh',
  з: 'z',
  и: 'i',
  й: 'y',
  к: 'k',
  л: 'l',
  м: 'm',
  н: 'n',
  о: 'o',
  п: 'p',
  р: 'r',
  с: 's',
  т: 't',
  у: 'u',
  ф: 'f',
  х: 'kh',
  ц: 'ts',
  ч: 'ch',
  ш: 'sh',
  щ: 'shch',
  ы: 'y',
  ь: '',
  ъ: '',
  э: 'e',
  ю: 'yu',
  я: 'ya'
};

const capitalizeFirst = (value: string): string => {
  if (!value) return value;
  return value.charAt(0).toUpperCase() + value.slice(1).toLowerCase();
};

export const transliterateForFilename = (value: string): string => {
  const transliterated = Array.from(value.trim())
    .map((char) => {
      const lower = char.toLowerCase();
      if (TRANSLIT_MAP[lower] !== undefined) {
        return TRANSLIT_MAP[lower];
      }
      if (/[a-z0-9_]/i.test(char)) {
        return char;
      }
      if (/\s/.test(char)) {
        return '_';
      }
      return '';
    })
    .join('')
    .replace(/_+/g, '_')
    .replace(/^_|_$/g, '');

  return capitalizeFirst(transliterated || 'Unknown');
};
